import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://app.renuviarx.com/api';
const API_KEY = import.meta.env.VITE_API_KEY;

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    ...(API_KEY && { 'X-API-KEY': API_KEY })
  },
  timeout: 30000 // 30 second timeout
});

// Request interceptor for logging (dev only)
if (import.meta.env.VITE_ENV === 'development') {
  apiClient.interceptors.request.use(
    (config) => {
      console.log('🚀 API Request:', {
        method: config.method,
        url: config.url,
        data: config.data
      });
      return config;
    },
    (error) => {
      console.error('❌ Request Error:', error);
      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(
    (response) => {
      console.log('✅ API Response:', {
        status: response.status,
        data: response.data
      });
      return response;
    },
    (error) => {
      console.error('❌ Response Error:', {
        status: error.response?.status,
        data: error.response?.data
      });
      return Promise.reject(error);
    }
  );
}

// API endpoints
export const api = {
  // Session Management
  createSession: () => apiClient.post('/sessions/', {}),

  // Question Management
  saveAnswer: (sessionId, questionId, answer) =>
    apiClient.post(`/questions/sessions/${sessionId}/questions/${questionId}`, answer),

  bulkUpdateAnswers: (sessionId, answers) =>
    apiClient.put(`/sessions/${sessionId}/`, answers),

  completeSession: (sessionId, formData) =>
    apiClient.post(`/sessions/${sessionId}/complete`, formData),

  // Lead Management
  createLead: (leadData) => apiClient.post('/leads/', leadData),

  updateLead: (userId, leadData) => apiClient.put(`/leads/${userId}/`, leadData),

  // Metadata
  getQuestions: () => apiClient.get('/questions/'),

  getProducts: () => apiClient.get('/products/'),

  // Health check
  healthCheck: () => apiClient.get('/health/')
};

export default api;
